import Heading from "../Heading/Heading";
import { Box, Typography } from "@mui/material";
import classes from './Message.module.css'

const Message = () => {

    return (
        <Box mb={2}>
            <Heading text={'No Student Records Available for Re-Enrolment'} />
            <center><Typography className={classes.longtext}>We would like to inform you that there are currently no students available for re-enrolment under your parent profile. At present, your only child enrolled at the school is in Year 12, or was transferred to another college and therefore not eligible for re-enrolment for the upcoming academic year.
If you wish to enrol another child at our school, please contact our admissions team at <b>(08) 9362 2100</b><br /> or visit our website: <a href="https://aic.wa.edu.au/">https://aic.wa.edu.au/</a> for further information.
<br /><br />Thank you for your understanding.</Typography></center>
        </Box>
    )

}

export default Message